<form fxLayout="column" [formGroup]="parent">
  <div>
     <mat-form-field appearance="none" class="no-padding no-line marginRight half-field" [class.validation-error]="submitted">
      <mat-label>Anteil (Bruch: m/n)</mat-label>
      <input matInput maxlength="10" pattern="\d{1,9}/\d{1,9}" required formControlName="anteil" appTrim/>
    </mat-form-field>
  </div>
</form>
